module.exports = __webpack_public_path__ + "static/img/login1.1e6c2079.png";